export {
    playInputSound,
    playButtonClickSound,
    playButtonDialogClickSound,
    playDropdownClickSound,
    playTabClickSound,
    playCardOverSound,
} from '@wg/web2clientapi/sound';
